module.exports = __webpack_public_path__ + "static/img/工地-1.c2a451a9.png";